import React, { useContext } from 'react';
import Overlay from '@/v2/components/atoms/Overlay';
import { StateContext } from '@/v2/state/store';
import DisclaimerText from '@/v2/components/layouts/DisclaimerText';

import './DisclaimerOverlay.scss';

const DisclaimerOverlay = () => {
    const store = useContext(StateContext);
    const { dispatch } = store;
    const { disclaimerOverlayVisible, disclaimerdata } = store.state;

    const hideDisclaimerOverlay = () => {
        dispatch({ type: 'HIDE_DISCLAIMER_OVERLAY' });
    };

    return (
        <div className="DisclaimerOverlay">
            <Overlay open={disclaimerOverlayVisible} onAnimationEndCallback={hideDisclaimerOverlay}>
                <DisclaimerText data={disclaimerdata} />
            </Overlay>
        </div>
    );
};

export default DisclaimerOverlay;
